var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "comment-display" }, [
    _vm.displayMode === "text"
      ? _c("div", [
          _vm.hasVisibleComment
            ? _c(
                "div",
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "div",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass:
                                          "text-truncate text-sm comment-display__text"
                                      },
                                      "div",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [_vm._v(" " + _vm._s(_vm.commentText) + " ")]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2986224633
                      )
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "comment-display__tooltip",
                          style: _vm.resolvedTooltipStyle
                        },
                        [_vm._v(" " + _vm._s(_vm.resolvedTooltipText) + " ")]
                      )
                    ]
                  )
                ],
                1
              )
            : _c("div", [_vm._v(" - ")])
        ])
      : _vm.displayMode === "icon"
      ? _c(
          "div",
          [
            _c(
              "v-tooltip",
              {
                attrs: { top: "" },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      var attrs = ref.attrs
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            _vm._b(
                              {
                                staticClass: "comment-display__icon-btn",
                                style: {
                                  visibility: _vm.resolvedIconVisibility
                                },
                                attrs: { icon: "", small: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.handleClick($event)
                                  }
                                }
                              },
                              "v-btn",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _c("icon-svg", {
                              attrs: {
                                color: _vm.resolvedIconColor,
                                size: "16",
                                name: "mdi-note-edit-outline"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "comment-display__tooltip",
                    style: _vm.resolvedTooltipStyle
                  },
                  [_vm._v(" " + _vm._s(_vm.resolvedTooltipText) + " ")]
                )
              ]
            )
          ],
          1
        )
      : _c("div", [_vm._v(" - ")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }